<template>
	<div class="question-wrap">
		<el-tooltip effect="dark" :content="content" placement="right">
			<i class="el-icon-question"></i>
		</el-tooltip>
	</div>
</template>
<script>
export default {
	name: "question",
	props: {
		content: {
			type: String,
			default: "排序越大越靠前，默认为50"
		}
	}
};
</script>
<style lang="less" scoped>
.question-wrap {
    margin-left: 4px;
    display: inline-block;
    vertical-align: middle;
	.el-icon-question {
        font-size: 18px;
        cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/question.vue